import { HttpStatusCode } from "axios";
import networkService from "./NetworkService";
import IAddress from "../models/localisation/IAddress";

class AddressService {

    /**
     * @description Gets all addresses
     */
    async getAddresses(): Promise<IAddress[]> {
        const result = await networkService.get<IAddress[]>('/addresses');

        if (!result.isSuccessful) {
            throw result.data;
        }

        if (result.status === HttpStatusCode.NoContent) {
            return [];
        }

        const addresses = result.data as IAddress[];
        return addresses;
    }

    /**
     * @description Gets the specified address
     * @param {string} id The ID of the address to be returned
     */
    async getAddress(id: string): Promise<IAddress> {
        const result = await networkService.get<IAddress>(`/address/${id}`);

        if (!result.isSuccessful) {
            throw result.data;
        }

        const address = result.data as IAddress;
        return address;
    }

    /**
     * @description Gets the local address
     */
    async getLocalAddress(): Promise<IAddress> {
        const result = await networkService.get<IAddress>("/address");

        if (!result.isSuccessful) {
            throw result.data;
        }

        const address = result.data as IAddress;
        return address;
    }

    /**
     * @description Creates an address
     * @param {IAddress} address The address to be created
     */
    async createAddress(address: IAddress): Promise<string> {
        const result = await networkService.put<IAddress, string>('/address', address);
        
        if (result.isSuccessful) {
            return result.data as string;
        }

        throw result.data;
    }

    /**
     * @description Updates an address
     * @param {IAddress} address The address to be updated
     */
    async updateAddress(address: IAddress): Promise<boolean> {
        const result = await networkService.patch<IAddress, void>('/address', address);
        return result.isSuccessful;
    }

    /**
     * @description Deletes the specified address
     * @param {string} id The ID of the address to be deleted
     */
    async deleteAddress(id: string, countryId: string): Promise<boolean> {
        const result = await networkService.delete<void>(`/address/${id}`, {
            "X-COUNTRY-ID": countryId
        });
        
        return result.isSuccessful;
    }

}

const addressService = new AddressService();
export default addressService;
